<!--used to show and hide details (click '+' to show and '-' to hide)
component used in Overview.vue, Emails.vue, BlackList.vue and WhiteList.vue
In (ui) anywhere like in organisations-> overview
-->
<template>
  <div>
    <v-row class="legendHead mt-4 px-1" no-gutters>
      <h2>{{ title }}</h2>
      <v-spacer></v-spacer>
      <div @click="toggle" :data-test-id="`${dataTestId}__toggle-btn`">
        <v-icon color="#58e2c2" size="25" v-if="!value">add</v-icon>
        <v-icon class="icon-top" color="#58e2c2" size="25" v-if="value">
          maximize
        </v-icon>
      </div>
    </v-row>
    <slot v-if="value" name="accordian_content"></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    defaultState: {
      type: Boolean,
      default: false
    },
    dataTestId: String
  },
  data() {
    return {
      value: this.defaultState
    };
  },
  methods: {
    // to toggle (change the value to its opposite)
    toggle() {
      this.value = !this.value;
    }
  }
};
</script>
<style scoped></style>
